import { useGeneratePath, useStaticUrls, useAppContext } from 'platform-components';
//@ts-ignore
import { Route, Switch } from 'platform-components/src/components/router/router';
import React, { useEffect } from 'react';
import { useUpdateEffect } from 'react-use';
import { getShouldShowModal } from 'common.components/lesson-view.store/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { useIframeMessage } from 'hooks/useIframeMessage';

import * as userSelectors from 'common.components/user/selectors';
import * as courseSelectors from 'store/courses/selectors';

import { SpecCourseLessonSSRContainer } from '../spec-course.lesson-view/lesson-view.container.ssr';
import { SpecCourseLessonsPageSSRContainer } from '../spec-course.lessons-page/lessons-page.container.ssr';
import { specCourseActions } from '../spec-course.store/actions';
import * as selectors from '../spec-course.store/selectors';

import { SpecCourseStubContent } from './__stub/spec-course__stub';

import './spec-course.scss';

const SPEC_LESSON_CARD_MESSAGE = 'specMessage';

export const SpecCourseContainer = () => {
    const sendToParent = useIframeMessage(SPEC_LESSON_CARD_MESSAGE);

    const toggleModal = useSelector(getShouldShowModal);

    // отправка сообщений из iframe
    useUpdateEffect(() => {
        if (!toggleModal) {
            sendToParent({ type: SPEC_LESSON_CARD_MESSAGE, showModal: false });
        }
    }, [sendToParent, toggleModal]);

    const dispatch = useDispatch();
    const { labClassSpecCourse, labClassSpecCourseStub, labClassSpecCourseLesson } = useStaticUrls();
    const { initialRender } = useAppContext();
    const { classId: clId, courseId: courseIdFromParams } = useParams<Record<string, string | undefined>>();
    const classId = Number(clId);

    const specCourseId = useSelector((store) => courseSelectors.getSpecCourseId(store, { classId }));
    const getRouterPath = useGeneratePath();
    const history = useHistory();
    const isLoading = useSelector(selectors.getIsSomethingLoading);
    const teamLetter = useSelector((store) => userSelectors.getCurrentTeamLetter(store, { classId }));
    const teamNumber = useSelector((store) => userSelectors.getCurrentTeamLevel(store, { classId }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const tryRedirectToCourse = (teamId: number | null, courseId: number | null) => {
        const shouldRedirect = courseId !== Number(courseIdFromParams);

        if (teamId && courseId && shouldRedirect) {
            history.push(getRouterPath(labClassSpecCourse, { classId: teamId, courseId }) + history.location.search);

            return true;
        }

        return false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initCourses = () => {
        if (classId && !specCourseId) {
            dispatch(
                specCourseActions.initCourses({
                    teamId: classId,
                    onSuccess: tryRedirectToCourse,
                })
            );
        }
    };

    useEffect(
        function tryRedirectAndLoadData() {
            if (!initialRender) {
                const hasSuccessfullyRedirected = tryRedirectToCourse(classId, specCourseId);
                if (!hasSuccessfullyRedirected) {
                    initCourses();
                }
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [classId, specCourseId, courseIdFromParams]
    );

    return (
        <Switch>
            <Route
                component={SpecCourseLessonSSRContainer}
                exact
                key="specCourseRoute"
                path={labClassSpecCourseLesson}
            />
            <Route component={SpecCourseLessonsPageSSRContainer} exact={true} path={labClassSpecCourse} />
            <Route
                component={() => (
                    <SpecCourseStubContent
                        isLoading={isLoading && !specCourseId}
                        teamLetter={teamLetter}
                        teamNumber={teamNumber}
                    />
                )}
                exact={true}
                path={labClassSpecCourseStub}
            />
        </Switch>
    );
};
